import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Commons } from '../shared/utils/commons';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  storageUrl: string = environment.apiCoreUrl + '/storage'

  constructor(private http: HttpClient) { }

  getImage(fileName: string) {
    const options = {
      headers: new HttpHeaders({
        'Accept': 'image/webp,*/*',
        Authorization: Commons.sessionCredentials()
      }),
      responseType: 'blob' as 'json'
    }
    return this.http.get<Blob>(this.storageUrl + '?filename=' + fileName, options)
  }

  getDocument(fileName: string) {
    const options = {
      headers: new HttpHeaders({
        'Accept': '*/*',
        Authorization: Commons.sessionCredentials()
      }),
      responseType: 'blob' as 'json'
    }
    return this.http.get<Blob>(this.storageUrl + '?filename=' + fileName, options)
  }

  attachFile(fileToUpload: File, sign: string) {
    var data = new FormData();
    data.append('attachment', fileToUpload);

    const options = {
      headers: new HttpHeaders({
        'Accept': 'image/webp,*/*',
        'sign': sign,
        Authorization: Commons.sessionCredentials()
      }),
    }

    return this.http.post<any>(this.storageUrl, data, options)
  }

  attachProductLogo(productName: string, fileToUpload: File, sign: string) {
    var data = new FormData();
    data.append('attachment', fileToUpload);

    const options = {
      headers: new HttpHeaders({
        'Accept': 'image/webp,*/*',
        'sign': sign,
        'product-name': productName,
        Authorization: Commons.sessionCredentials()
      }),
    }

    return this.http.post<any>(this.storageUrl, data, options)
  }

  getProductImage(fileName: string) {
    const options = {
      headers: new HttpHeaders({
        'Accept': 'image/webp,*/*'
      }),
      responseType: 'blob' as 'json'
    }
    return this.http.get<Blob>(this.storageUrl + '/product?filename=' + fileName, options)
  }

}
